import React, { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const TaskmanagerAddModal = ({ setAddTaskModal, refreshTaskList }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    status: "pending",
    due_date: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onClose = () => {
    setAddTaskModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let userToken = localStorage.getItem("token");
    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/task/add/`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData },
    };

    axios(config)
      .then(function (response) {
        toast.success("Task Created Successfully.");
        if (refreshTaskList) {
          refreshTaskList();
        }
        setAddTaskModal(false);
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error.response.data));
      });
  };

  // if (!isOpen) return null;

  return (
    <div className="w-full p-6 bg-white rounded-lg">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Title
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            maxLength={255}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
            placeholder="Enter task title"
          />
        </div>

        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            maxLength={550}
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
            placeholder="Enter task description"
          />
        </div>

        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Status
          </label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
          >
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
          </select>
        </div>

        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Due Date
          </label>
          <DatePicker
            showTime
            name="due_date"
            value={formData.due_date ? dayjs(formData.due_date) : null}
            onChange={(date) => {
              handleChange({
                target: {
                  name: "due_date",
                  value: date ? date.format("YYYY-MM-DD HH:mm:ss") : null,
                },
              });
            }}
            required
            className="w-full h-12"
          />
        </div>

        <div className="flex justify-end pt-4 space-x-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Add Task
          </button>
        </div>
      </form>
    </div>
  );
};

export default TaskmanagerAddModal;
